module.exports=require("./LottieView");